"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const convert = (magnitude, source, target, { base, rates }) => {
    if (source === target) {
        return magnitude;
    }
    if (source === base) {
        return magnitude * rates[target];
    }
    if (target === base) {
        return magnitude / rates[source];
    }
    return (magnitude / rates[source]) * rates[target];
};
exports.default = convert;
